module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n	<h1 class="xHeading xTitle">'+
((__t=( NGX.lang.get('browser.unsupported.title') ))==null?'':_.escape(__t))+
'</h1>\n	<p class="xCopy">'+
((__t=( NGX.lang.get('browser.unsupported.message') ))==null?'':_.escape(__t))+
'</p>\n	';
 if(typeof allowContinue !== "undefined" && allowContinue===true){
__p+='\n		<a href="#" class="xButton">'+
((__t=( NGX.lang.get('browser.unsupported.continue') ))==null?'':_.escape(__t))+
'</a>\n	';
 } 
__p+='\n</div>\n';
}
return __p;
};
